import { ActiveSubscriptions } from '../components/subscriptions/ActiveSubscriptions.tsx'

export function ManageSubscriptionsPage() {
  return (
    <main>
      <ActiveSubscriptions />
    </main>
  )
}
